import { UserRights, UserRoles } from '../types';

export const UserRightsByRole: Partial<Record<UserRoles, UserRights>> = {
  [UserRoles.Orion_Administrator]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    generateInstructions: {
      canGenerateInstructions: true,
      documents: {
        canDelete: true,
        canDownload: true,
        canUpload: true,
      },
    },
    portfolioRights: {
      addition: {
        create: true,
        delete: true,
        edit: true,
      },
      bulkEdit: true,
      create: true,
      delete: true,
      download: true,
      edit: true,
      subforms: true,
      upload: true,
    },
    slotsCalendar: {
      canDownload: true,
    },
    slotsPage: {
      documents: {
        canDelete: true,
        canUpload: true,
      },
      shipments: {
        canCreate: true,
        canDelete: true,
      },
    },
    uploadDocumentsPage: {
      canGenerateInstructions: true,
      canSearch: true,
      documents: {
        canDelete: true,
        canDownload: true,
        canUpload: true,
      },
    },
  },
  [UserRoles.Orion_AI]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
    },
  },
  [UserRoles.Orion_AI_Analyst]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
    },
  },
  [UserRoles.Orion_CTP]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
  },
  [UserRoles.Orion_Finance_Accountant]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
    },
  },
  [UserRoles.Orion_Finance_Analyst]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
    },
  },
  [UserRoles.Orion_JUSDA]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
  },
  [UserRoles.Orion_Logistics_Analyst]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    generateInstructions: {
      canGenerateInstructions: true,
      documents: {
        canDelete: true,
        canDownload: true,
        canUpload: true,
      },
    },
    portfolioRights: {
      download: true,
      subforms: true,
    },
    uploadDocumentsPage: {
      canGenerateInstructions: true,
      canSearch: true,
      documents: {
        canDelete: true,
        canDownload: true,
        canUpload: true,
      },
    },
  },
  [UserRoles.Orion_Logistics_Carrier]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    generateInstructions: {
      canGenerateInstructions: true,
      documents: {
        canDelete: true,
        canDownload: true,
        canUpload: true,
      },
    },
    portfolioRights: {
      download: true,
    },
    uploadDocumentsPage: {
      canGenerateInstructions: true,
      canSearch: true,
      documents: {
        canDelete: true,
        canDownload: true,
        canUpload: true,
      },
    },
  },
  [UserRoles.Orion_Logistics_Declarant]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
    },
  },
  [UserRoles.Orion_Logistics_Logistic]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    generateInstructions: {
      canGenerateInstructions: true,
      documents: {
        canDelete: true,
        canDownload: true,
        canUpload: true,
      },
    },
    portfolioRights: {
      download: true,
    },
    uploadDocumentsPage: {
      canGenerateInstructions: true,
      canSearch: true,
      documents: {
        canDelete: true,
        canDownload: true,
        canUpload: true,
      },
    },
  },
  [UserRoles.Orion_Logistics_Readonly]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
    },
  },
  [UserRoles.Orion_Logistics_Slot]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
      subforms: true,
    },
    slotsCalendar: {
      canDownload: true,
    },
    slotsPage: {
      documents: {
        canDelete: true,
        canUpload: true,
      },
      shipments: {
        canCreate: true,
        canDelete: true,
      },
    },
  },
  [UserRoles.Orion_Logistics_Warehouse]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    generateInstructions: {
      documents: {
        canDelete: true,
        canDownload: true,
        canUpload: true,
      },
    },
    portfolioRights: {
      download: true,
    },
    slotsCalendar: {
      canDownload: true,
    },
    slotsPage: {
      documents: {
        canUpload: true,
      },
      shipments: {
        canCreate: true,
        canDelete: true,
      },
    },
    uploadDocumentsPage: {
      canSearch: true,
      documents: {
        canDelete: true,
        canDownload: true,
        canUpload: true,
      },
    },
  },
  [UserRoles.Orion_Multi]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
    },
  },
  [UserRoles.Orion_SCM_Analyst]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      addition: {
        create: true,
        delete: true,
        edit: true,
      },
      bulkEdit: true,
      create: true,
      delete: true,
      download: true,
      edit: true,
      subforms: true,
      upload: true,
    },
  },
  [UserRoles.Orion_SCM_Buyer]: {
    portfolioRights: {
      addition: {
        create: true,
        delete: true,
        edit: true,
      },
      bulkEdit: true,
      create: true,
      download: true,
      edit: true,
      subforms: true,
      upload: true,
    },
  },
  [UserRoles.Orion_SCM_Customer]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
    },
  },
  [UserRoles.Orion_SCM_Customer_Commit]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
    },
  },
  [UserRoles.Orion_SCM_Engineering]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
    },
  },
  [UserRoles.Orion_SCM_Master_Buyer]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      addition: {
        create: true,
        delete: true,
        edit: true,
      },
      bulkEdit: true,
      create: true,
      delete: true,
      download: true,
      edit: true,
      subforms: true,
      upload: true,
    },
  },
  [UserRoles.Orion_SCM_ReadOnly]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
    },
  },
  [UserRoles.Orion_SCM_Sourcing]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
    },
  },
  [UserRoles.Orion_SCM_Supplier_BS]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
    },
  },
  [UserRoles.Orion_SCM_Supplier_Commit]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
    },
  },
  [UserRoles.Orion_SCM_Supplier_No_Commit]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
    },
  },
  [UserRoles.Orion_SCM_Supplier_ROP]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
    },
  },
  [UserRoles.Orion_Warehouse_Analyst]: {
    contactsPage: {
      canCreate: true,
      canEdit: true,
      canUpload: true,
    },
    portfolioRights: {
      download: true,
      subforms: true,
    },
    slotsCalendar: {
      canDownload: true,
    },
    slotsPage: {
      documents: {
        canDelete: true,
        canUpload: true,
      },
      shipments: {
        canCreate: true,
        canDelete: true,
      },
    },
  },
};
